export enum Header {
  FREDHOPPER_SEGMENT = 'x-ab-fredhopper-segment',
  COOKIE_LEVEL = 'x-cookie-level',
  COOKIE_LEVEL_SET = 'x-cookie-level-set',
  COOKIE_CONSENT_SETTING = 'x-cookie-consent-setting',
  VARNISH_IP = 'x-varnish-ip',
  ESI_PARENT_URL = 'x-esi-parent',
}
